import { captureError, SENTRY_SEVERITY, toApiError } from '@/shared/sentry'
import { RefundTermsResponseType } from '@/shared/types/api'

const TELECOM_KEYS = ['SKTTerms', 'KTTerms', 'LGUPTerms'] as const

/** 이용 약관 검증 */
export function captureTermsError(
  body?: {
    SKTTerms?: { Terms?: { Title?: string; Contents?: string }[] }
    KTTerms?: { Terms?: { Title?: string; Contents?: string }[] }
    LGUPTerms?: { Terms?: { Title?: string; Contents?: string }[] }
  } | null,
) {
  if (!body) return

  TELECOM_KEYS.forEach((telecom) => {
    body[telecom]?.Terms?.forEach((term) => {
      const title = term.Title?.trim()
      const contents = term.Contents?.trim()

      if (!title || contents) return

      captureError(toApiError(new Error(`[${telecom} : ${title}] Contents 누락`)), {
        level: SENTRY_SEVERITY.Error,
        tags: { type: 'HomeTerms', telecom, termKey: title },
        fingerprint: ['terms-missing', telecom, title],
      })
    })
  })
}

/** 환불 약관 검증 */
export function captureRefundTermsError(body?: RefundTermsResponseType) {
  if (!body) return

  const title = body.LgupTitle?.trim()
  const contents = body.LgupTerms?.trim()

  if (!title && !contents) return

  if (!title) {
    captureError(toApiError(new Error('[환불약관] Title 누락')), {
      level: SENTRY_SEVERITY.Error,
      tags: { type: 'RefundTerms' },
      fingerprint: ['terms-missing', 'RefundTerms', 'Title'],
    })
  }

  if (!contents) {
    captureError(toApiError(new Error('[환불약관] Contents 누락')), {
      level: SENTRY_SEVERITY.Error,
      tags: { type: 'RefundTerms' },
      fingerprint: ['terms-missing', 'RefundTerms', 'Contents'],
    })
  }
}
